/**
 * Created by Armaldio on 11/01/2018.
 */
import Addon from './Addon'

export default Addon;



// WEBPACK FOOTER //
// ./src/components/Addon/index.js